import { createFileRoute } from '@tanstack/react-router';
import { Translation } from '../../feature/translation/translation';
import * as Sentry from '@sentry/react';

export const Route = createFileRoute('/_authenticated/')({
    component: RouteComponent,
});

function RouteComponent() {
    return (
        <Sentry.ErrorBoundary fallback={<p>Something went wrong</p>}>
            <Translation />
        </Sentry.ErrorBoundary>
    );
}
